import { render } from "./com_compras_ticket.vue?vue&type=template&id=478933ae&scoped=true"
import script from "./com_compras_ticket.vue?vue&type=script&lang=js"
export * from "./com_compras_ticket.vue?vue&type=script&lang=js"

import "./com_compras_ticket.vue?vue&type=style&index=0&id=478933ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478933ae"]])

export default __exports__